<template>
  <v-container fluid>
    <v-layout
      v-if="loading"
      align-space-around
      justify-space-around
      column
      fill-height
    >
      <v-flex>
        <v-progress-circular
          :size="50"
          color="secondary"
          indeterminate
        />
      </v-flex>
    </v-layout>
    <v-layout
      v-else
      align-space-around
      justify-space-around
      column
      fill-height
    >
      <div v-if="pois && Object.keys(pois).length > 0">
        <v-flex>
          <h1>{{ strings.outstanding }}</h1>
        </v-flex>
        <v-flex
          v-for="poi in pois"
          :key="poi.id"
        >
          <OutstandingPoi :poi="poi" />
        </v-flex>
      </div>
      <div v-else>
        <v-flex>
          <h1>{{ strings.noneOutstanding}}</h1>
        </v-flex>
      </div>
      <v-flex>
        <v-btn
          color="primary"
          @click="onGoToGroups"
        >
          {{ strings.returnToGroups }}
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import OutstandingPoi from "@/components/OutstandingPoiQL.vue";
import { mapGetters } from "vuex";
export default {
  name: "Outstanding",
  components: {
    OutstandingPoi
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapGetters("login", {
      userId: "userId",
      technicianId: "technicianId"
    }),
    ...mapGetters("group", ["activeGroup"]),
    ...mapGetters("poi", ["groupPois"]),
    ...mapGetters("page", ["strings"]),
    groupId() {
      return Number(this.$route.params.id);
    },
    pois() {
      return this.groupPois.filter(p => p.customerGroupId == this.activeGroup);
    }
  },
  async created() {
    if (this.$route.params.id != null) {
      this.$store.commit("group/setActiveGroup", this.groupId);
      this.loading = true;
      await this.$store.dispatch("poi/GetPoisByGroups", this.groupId);
      this.loading = false;
    }
  },
  methods: {
    onGoToGroups() {
      this.$router
        .push({ name: "group", params: { id: this.activeGroup } })
        .catch(() => {});
    }
  }
};
</script>
<style scoped>
.v-btn {
  color: var(--v-text-base) !important;
}
</style>
